export function getTimeAtWhichGuardCanBeginPatrol(patrolStartTime: Date): Date {
	const minutesBeforeGuardCanBeginPatrol = 5; // A Guard can click on begin patrol 5 minutes before the start time

	// Create a new Date object for the adjusted patrol start time
	const adjustedPatrolStartTime = new Date(patrolStartTime.getTime());
	adjustedPatrolStartTime.setMinutes(
		patrolStartTime.getMinutes() - minutesBeforeGuardCanBeginPatrol,
	);

	return adjustedPatrolStartTime;
}

/**
 * If the current time is greater than the duration of the patrol since begin patrol was clicked, then we enable the edit report button
 * @param patrol
 * @returns
 */
export function getMinutesUntilEditButtonCanBeVisible(
	patrol: ScheduleAssignment,
): number {
	// NOTE(Some context for the following code):
	// start_time = the time the dispatcher has set the patrol to begin
	// patrol_begin_time = the time the patrol was actually started
	// end_time = the time the dispatcher has set the patrol to end
	// patrol_end_time = the time the patrol was actually ended
	//--------------------------------------------------//
	// FUNCTION LOGIC:
	// if the current time is greater that the duration of the patrol since begin patrol was clicked(i.e patrol_begin_time) then we enable the edit report button
	// the condition is as follows:
	// duration = (end_time - start_time)
	// if current_time > (patrol_begin_time + duration) then enable edit report button
	const MINUTE_MS = 60000; // milliseconds in a minute

	const patrolDurationInMinutes: any =
		(patrol.end_time.getTime() - patrol.start_time.getTime()) / MINUTE_MS;

	if (!patrol.patrol_begin_time)
		throw new Error('Patrol begin time is required');
	// Add patrolDurationInMinutes to patrolBeginTime and save in dateTimeEditButtonShouldBeEnabled:
	const dateTimeEditButtonShouldBeEnabled = new Date(
		patrol.patrol_begin_time.getTime(),
	);
	dateTimeEditButtonShouldBeEnabled.setMinutes(
		dateTimeEditButtonShouldBeEnabled.getMinutes() +
			patrolDurationInMinutes,
	);

	const minutesUntilEditButtonIsEnabled = getRemainingTime(
		dateTimeEditButtonShouldBeEnabled,
	);
	return minutesUntilEditButtonIsEnabled;
}

function getRemainingTime(time: Date): number {
	const currentTime: Date = new Date(); // Current date and time
	const diffInMilliseconds: number = time.getTime() - currentTime.getTime(); // Difference in milliseconds
	const diffInMinutes = Math.floor(diffInMilliseconds / 1000 / 60);
	return diffInMinutes;
}
